import {
  FB_LOGIN_AND_ME_LOADING,
  FB_LOGIN_AND_ME_FAILURE,
  FB_LOGIN_AND_ME_SUCCESS,
  FB_LOGIN_AND_ME_UNLOAD,
} from '../actions'

const defaultState = {
  data: null,
  loading: false,
  error: null,
}
export default (prevState = defaultState, { payload, type, error }) => {
  switch (type) {
    case FB_LOGIN_AND_ME_LOADING:
      return {
        ...prevState,
        error: null,
        loading: true,
      }
    case FB_LOGIN_AND_ME_SUCCESS:
      return {
        ...prevState,
        data: payload,
        loading: false,
      }
    case FB_LOGIN_AND_ME_FAILURE:
      return {
        ...prevState,
        error,
        loading: false,
      }
    case FB_LOGIN_AND_ME_UNLOAD:
      return defaultState
    default:
      return prevState
  }
}



// WEBPACK FOOTER //
// ./src/reducers/fb.js